"use client";

import { SUPPORT_EMAIL } from "@/config/service";

/**
 * Shown in place of any backend-dependent page while `SERVICE_PAUSED` is on.
 */
export function ServicePausedNotice() {
  return (
    <div className="service-paused-page">
      <div className="service-paused-card">
        <div className="service-paused-icon" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="10" rx="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
        <h1>Currently by Invitation Only</h1>
        <p>
          Govilo PayLink is currently available to invited partners only. Public
          access to payments, unlock links, and the seller dashboard is
          temporarily closed.
        </p>
        <p>
          To request an invitation or ask about an existing purchase, please
          contact us at the address below.
        </p>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="support-email">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
          {SUPPORT_EMAIL}
        </a>
        <a href="/" className="service-paused-back">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Back to home
        </a>
      </div>
    </div>
  );
}
